import React, { useState } from 'react'
import { formatPrice } from '../../helpers/formatPrice'
import View from './View'
import { t } from 'i18next'
import Text from './TextNew'

interface Props {
  value: number
  minimalPrice: number
  onSetValue: (val: number) => void
}

const PriceInput = ({ minimalPrice, onSetValue }: Props): JSX.Element => {
  const [inputValue, setInputValue] = useState({ number: 0, formattedNumber: '--' })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const targetValue = e.target.value.replace(/\D/g, '')
    const value = targetValue === '' ? 0 : parseInt(e.target.value.replace(/\D/g, ''), 10)
    onSetValue(value)
    setInputValue({ number: value, formattedNumber: `€ ${formatPrice(value)}` })
  }

  return (
    <View className="flex justify-center items-center flex-col bg-[white] rounded-4 overflow-hidden h-[70px]">
      <View className="flex-1 mt-1">
        <Text
          className="text-m text-errorRed font-Medium text-center"
          onClick={(e) => {
            e.stopPropagation()
          }}>
          {inputValue.number > 0 && minimalPrice > inputValue.number ? (
            <>
              {t('offer_to_low')} {formatPrice(minimalPrice)}
            </>
          ) : (
            <></>
          )}
        </Text>
      </View>
      <View className="">
        <input
          data-testid="price-input"
          className="text-xxl font-SemiBold text-center text-groupBlue outline-none leading-[100%]"
          value={inputValue.formattedNumber}
          onChange={handleChange}
          onClick={(e) => {
            e.stopPropagation()
          }}
        />
      </View>
      <View className="flex-1" />
    </View>
  )
}

export default PriceInput
